import UI from "components/UI";
import { UIInputNumberProps } from "components/atoms/input/UIInputNumber";
import React from "react";
import ObjectUtil from "utils/ObjectUtil";

export interface UIInputPriceKRWProps extends UIInputNumberProps {
  unitNumber?: number;
}

UIInputPriceKRW.defaultProps = {
  min: 0,
  max: 99999999999999,
  attrs: {},
} as UIInputPriceKRWProps;

export default UIInputPriceKRW;

/**
 * 원화금액 입력
 *
 * @param props
 */
function UIInputPriceKRW(props: UIInputPriceKRWProps) {
  if (props.attrs != null) {
    if (props.attrs?.prefix == null) {
      props.attrs.prefix = "";
    }

    if (props.attrs?.suffix == null) {
      props.attrs.suffix = "원";
    }

    //@ts-ignore
    if (props.attrs?.allowEmptyFormatting == null) {
      //@ts-ignore
      props.attrs.allowEmptyFormatting = false;
    }
  }

  if (props.unitNumber == null) {
    return <UI.InputNumber {...props} />;
  }

  return (
    <UI.InputNumber
      {...props}
      value={(() => {
        if (props.unitNumber == null) {
          return props.value;
        }

        if (props.value == null) {
          return undefined;
        }

        if (props.value >= props.unitNumber) {
          return props.value / props.unitNumber;
        }

        return props.value;
      })()}
      valueChanged={(value) => {
        if (props.valueChanged != null) {
          if (props.unitNumber != null) {
            props.valueChanged(value == null ? ObjectUtil.undefined : value * props.unitNumber);
          } else {
            props.valueChanged(value);
          }
        }
      }}
    />
  );
}
